import { useState } from 'react'
import CollectionDataGrid from '@/components/CollectionDataGrid'
import { pbUpsert, usePaginatedCollection } from '@/pb'
import { arrayToObject, useInputState } from '@/utils'
import { Button, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'

const Editor = ({ row, onClose }) => {
  const [name, setName] = useInputState(row?.name)
  const [address, setAddress] = useInputState(row?.address)

  return <>
    <DialogTitle>Тренажерка</DialogTitle>
    <DialogContent className="editorForm">
      <TextField label={fields.name.headerName} value={name} onChange={setName} />
      <TextField label={fields.address.headerName} value={address} onChange={setAddress} />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} >Отмена</Button>
      <Button onClick={() => pbUpsert('gyms', { id: row?.id, name, address }).then(onClose)} variant="contained">Сохранить</Button>
    </DialogActions>
  </>
}

const columns = [
  { field: 'name', headerName: 'Название', width: 300 },
  { field: 'address', headerName: 'Адрес', width: 300 },

]
const fields = arrayToObject(columns, 'field')

export default function Gyms({ title }) {
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  })

  const {
    records: gyms,
    totalItems,
    loaded,
  } = usePaginatedCollection('gyms', {
    page: paginationModel.page + 1,
    perPage: paginationModel.pageSize,
    sort: '-created',
  })

  return <>
    <CollectionDataGrid
      collectionName={title}
      collection={gyms}
      columns={columns}
      loading={!loaded}
      editor={Editor}
      serverPagination={true}
      rowCount={totalItems}
      paginationModel={paginationModel}
      onPaginationModelChange={setPaginationModel}
    />
  </>

}